import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OtkList } from '../../models/user-item-list';
import {
  CloseDialog,
  CreateList,
  EditList,
  OpenDialog,
  UpdateLocalList,
} from './edit-list.actions';
import { EditListState } from './edit-list.state';
import { Record } from '../../models/record';
import { CreateListRequest, UpdateListRequest } from '../services/models/list.request';
import { UserFacade } from 'src/app/_core/state/user/user.facade';

@Injectable({
  providedIn: 'root',
})
export class EditListFacade {
  private readonly store = inject(Store);
  private readonly userFacade = inject(UserFacade);

  @Select(EditListState.open) open$: Observable<boolean>;
  @Select(EditListState.list) list$: Observable<OtkList | undefined>;
  @Select(EditListState.record) record$: Observable<Record | undefined>;

  openDialog(list?: OtkList, record?: Record) {
    this.store.dispatch(new OpenDialog(list, record));
  }

  closeDialog() {
    this.store.dispatch(new CloseDialog());
  }

  updateLocalList(list: Partial<OtkList>) {
    this.store.dispatch(new UpdateLocalList(list));
  }

  createList(list: CreateListRequest, record?: Record) {
    this.store.dispatch(new CreateList(this.userFacade.user.id, list, record));
  }

  editList(list: UpdateListRequest) {
    this.store.dispatch(new EditList(list));
  }
}
